export default "__VITE_ASSET__3ea78980__"